module.exports = __webpack_public_path__ + "img/mini_zit.7a64833c.png";